export const magicTabs = [
  { name: "Our Service", value: "service" },
  { name: "Our Hygiene ", value: "hygiene" },
  { name: "Our Flavour", value: "flavour" },
];

export const serviceOptions = [
  { option: "Personalized weekly meal plans" },
  { option: "Made-to-order dishes — no pre-cooked stock" },
  { option: "Vegetarian, high-protein, low-carb" },
  { option: "Meals freshly packed right before delivery" },
  { option: "Bulk ordering for office/home" },
];
export const hygieneOptions = [
  { option: "Daily sanitization protocols (surfaces, tools)" },
  { option: "Regular health checks and certified food " },
  { option: "Use of fresh ingredients only — no leftovers" },
  { option: "Zero cross-contamination policy for allergen " },
  { option: "Periodic kitchen audits to maintain quality " },
];
export const flavourOptions = [
  { option: "Regional spices, traditional techniques)" },
  { option: "Slow cooking, marination, or clay pot usage" },
  { option: "No artificial enhancers — just authentic taste" },
  { option: "Balanced meals with nutritional planning" },
  { option: "Secret family touches passed down generations" },
];
